import React from "react";
import "../../Assets/css/paymentOptions.css";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import LoadingStatus from "../../Components/PolicyStatusComponents/LoadingStatus";
import usePolicyStatusPage from "./usePolicyStatus";
import { POLICY_STATUS } from "../PaymentOptionsPage/usePaymentOptions";
import CategoryHeader from "../../Components/Headers/CategoryHeader";
import CircularProgressBar from "../../Components/PersonalAccidentComponents/CircularProgressBar/CircularProgressBar";

const PolicyStatus = () => {
  const {
    transferData,
    proposalNumber,
    downloadPolicy,
    loading,
    backButtonHandler,
  } = usePolicyStatusPage();

  return (
    <>
      {transferData?.policyStatus === POLICY_STATUS.UNDERWRITING ? (
        <LoadingStatus status={5} data={""} proposerNum={proposalNumber} />
      ) : (
        <div>
          <CategoryHeader title="Personal Accident Insurance" />

          <Container
            style={{ marginTop: 10, marginBottom: 10 }}
            maxWidth="sm md lg"
          >
            <Card className="card-section" sx={{ minWidth: 275, marginTop: 5 }}>
              <Box sx={{ display: "flex", marginBottom: 4 }}>
                <img
                  className="bg-white img-thumbnail rounded"
                  width={100}
                  height={100}
                  src={transferData?.logo ?? ""}
                  alt="company_logo"
                />
                <Box style={{ margin: 16 }}>
                  <Typography>{transferData?.vendor ?? ""}</Typography>
                  <Typography>{transferData?.product_name ?? ""}</Typography>
                </Box>
              </Box>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={5}>
                    <Typography>Proposer Name:</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography>
                      <strong>{transferData?.proposerName ?? ""}</strong>
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography>Policy Type:</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography>
                      <strong>
                        {transferData?.number_of_insured > 1
                          ? "Floater"
                          : "Individual"}
                      </strong>
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography>Number of Insured(s):</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography>
                      {transferData?.number_of_insured ?? 0}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography></Typography>
                  </Grid>
                  <hr />
                  <Grid item xs={3}></Grid>
                </Grid>
              </CardContent>
            </Card>

            <div className="button-section">
              <div>
                {/* TODO: Loading and success button with animation */}
                {!loading ? (
                  <button
                    className="payment-btn"
                    type="button"
                    onClick={downloadPolicy}
                  >
                    Download Policy
                  </button>
                ) : (
                  <CircularProgressBar />
                )}
              </div>
              <div>
                <button
                  className="back-btn"
                  type="button"
                  disabled={loading}
                  onClick={backButtonHandler}
                >
                  Back
                </button>
              </div>
            </div>
          </Container>
        </div>
      )}
    </>
  );
};

export default PolicyStatus;
